import { render } from "./EditTrafficLabel.vue?vue&type=template&id=1f63f23a&scoped=true"
import script from "./EditTrafficLabel.vue?vue&type=script&lang=js"
export * from "./EditTrafficLabel.vue?vue&type=script&lang=js"

import "./EditTrafficLabel.vue?vue&type=style&index=0&id=1f63f23a&scoped=true&lang=less"

import exportComponent from "/home/biktorgj/Projects/Linube Cloud/Server_and_UI/ui-prod-4.22/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f63f23a"]])

export default __exports__